<template>

	<div class="user_wbox">
		<div class="inter">
			<div class="div1 t-flex">
				<div class="fl">

					<usermenu></usermenu>
				</div>
				<div class="fr">

					<div class="user_center">

						<div class="user_de_ti" style="margin-bottom: 30px;">修改密码</div>

						<div class="edit_pass_word">
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									旧密码
								</div>
								<div class="input">
									<el-input v-model="pass" show-password placeholder="请输入旧密码"></el-input>
								</div>

							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									新密码
								</div>
								<div class="input">
									<el-input v-model="pass1" show-password placeholder="请输入新密码"></el-input>
								</div>
							</div>
							<div class="item t-flex t-flex-items-center">
								<div class="lable">
									确认新密码
								</div>
								<div class="input">
									<el-input v-model="pass2" show-password placeholder="请确认新密码"></el-input>
								</div>
							</div>
							<div style="padding-top: 20px;">
								<div class="debtn" @click="editPass">确认提交</div>
							</div>

						</div>



					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
import usermenu from '@/components/dialogs/usermenu'
import {
	Notification,
	Message
} from 'element-ui'
import moment from 'moment';
export default {
	components: {
		usermenu

	},
	data() {
		return {
			list: [],
			content: "",
			active: 2,
			title: "",
			info: {},
			acc: "",
			pass: "",
			pass2: "",
			code: "",
			menu_id: 4,
			menu: [{
				id: 1,
				name: "基本资料",
				url: "/user"
			},
			{
				id: 7,
				name: "实名认证",
				url: "/shiming"
			},
			{
				id: 2,
				name: "我的收藏",
				url: "/shoucang"
			},
			// {
			// 	id: 3,
			// 	name: "我发布的账号",
			// },
			{
				id: 6,
				name: "我的订单",
				url: "/order"
			},
			{
				id: 4,
				name: "修改密码",
				url: "/editpass"
			},
			{
				id: 5,
				name: "退出登录",
			}
			],
			page: 1,
			list: [],
			pagination: {
				total: 0,
				per_page: 0,
			},
			pass: "",
			pass1: "",
			pass2: ""

		}
	},
	computed: {
		userinfo() {
			return this.$store.getters.userinfo
		}
	},
	created: function (data) {

		// this.getDetail();


	},
	watch: {
		$route() {

		}
	},
	methods: {
		formatTimestamp(timestamp) {
			return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
		},
		open(item) {
			if (item.id == 5) {
				localStorage.removeItem('usertoken')
				sessionStorage.removeItem('usertoken')
				localStorage.setItem('path', this.$route.path)
				this.$router.replace("/")
			} else {

				this.$router.replace(item.url)
			}
		},



		editPass() {
			var that = this
			this.rq.requests.post("api/game/user/editpass", {
				oldpassword: that.pass,
				newpassword: that.pass1,
				renewpassword: that.pass2,
			}).then(res => {

				Message.success({
					message: "修改成功",
					duration: 3000
				})
				localStorage.removeItem('usertoken')
				sessionStorage.removeItem('usertoken')

				setTimeout(function () {
					that.$router.push("/login")

				}, 1000);


			}).catch(error => {

			})

		},




	}


}
</script>